<div
  *ngIf="steps.length > 0"
  class="position-relative d-flex gap-2 align-items-center flex-nowrap sticky-top"
>
  <ng-container *ngFor="let step of steps; let i = index; let last = last">
    <a
      *ngIf="step.step_url && step.completed; else nonClickableStep"
      class="text-truncate flex-shrink-0 cursor-pointer link-body-emphasis progress-stepper-link"
      [ngClass]="{ 'd-none d-lg-inline-block': !step.active }"
      href="javascript:void(0)"
      (click)="navigateToStep(step.step_url)"
    >
      <ts-progress-stepper-badge
        size="sm"
        [attr.aria-label]="step.completed ? 'Step ' + (i + 1) + ' completed' : undefined"
        [label]="i + 1"
        [icon]="step.completed ? 'done' : undefined"
        [variant]="step.active || step.completed ? 'primary' : 'secondary'"
        [ngClass]="{ 'flex-shrink-0': true }"
      />
      <small
        class="ms-2 text-truncate flex-shrink-0"
        [innerHTML]="step.step_name | domSanitizer"
      ></small>
    </a>
    <ng-template #nonClickableStep>
      <ts-progress-stepper-badge
        size="sm"
        [attr.aria-label]="step.completed ? 'Step ' + (i + 1) + ' completed' : undefined"
        [label]="i + 1"
        [icon]="step.completed ? 'done' : undefined"
        [variant]="step.active || step.completed ? 'primary' : 'secondary'"
        [ngClass]="{ 'flex-shrink-0': true, 'd-none d-lg-inline-block': !step.active }"
      />
      <small
        [ngClass]="[
          'text-truncate flex-shrink-0',
          step.active ? 'fw-medium d-inline-block' : 'd-none d-lg-inline-block'
        ]"
      >
        {{ step.step_name }}
      </small>
    </ng-template>

    <hr
      *ngIf="!last"
      class="h-2px m-0 progress-bar-separator flex-grow-1 d-none d-lg-inline-block"
    />
  </ng-container>

  <ts-menu-button
    class="position-absolute end-0 bottom-0 d-lg-none"
    buttonClass="neutral-btn hide-pseudo-elements"
    menuItemClass="fs-5 d-flex align-items-center gap-2"
    aria-label="Shopping navigation menu"
    [links]="navigationLinks()"
  >
    <ng-template #menuButton>
      <tds-progress-spinner
        size="xl"
        [label]="progressSpinnerLabel()"
        [progress]="progressSpinnerProgress()"
      />
    </ng-template>
    <ng-template #menuItem let-link>
      <span class="material-icons fs-inherit bg-primary text-white rounded-circle p-1">done</span>
      <span>{{ link.label }}</span>
    </ng-template>
  </ts-menu-button>
</div>
